<!-- src/components/Skeleton.vue -->
<template>
  <div
    :class="['skeleton', rounded ? 'rounded' : '', animated ? 'animated' : '']"
    :style="{
      height,
      width,
      marginBottom: margin,
    }"
  />
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    height: { type: String, default: '1rem' },
    width: { type: String, default: '100%' },
    margin: { type: String, default: '0.5rem' },
    rounded: { type: Boolean, default: true },
    animated: { type: Boolean, default: true }
  }
};
</script>

<style scoped>
.skeleton {
  background-color: #e0e0e0;
  display: inline-block;
}

.rounded {
  border-radius: 6px;
}

.animated {
  animation: shimmer 1.5s infinite linear;
  background: linear-gradient(
    90deg,
    #e0e0e0 0%,
    #f0f0f0 50%,
    #e0e0e0 100%
  );
  background-size: 200% 100%;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
